module.exports = __webpack_public_path__ + "img/rg-active.82320692.png";